module.exports = __webpack_public_path__ + "img/ijcse-nlogo.ef157928.png";